function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var promoService = require('../../module/PTFs/promo.js');
var _require = require('../../utils.js'),
  isNumeric = _require.isNumeric,
  round = _require.round;
var mypromos = [];
var _getPromoDescriptionPrefix = function _getPromoDescriptionPrefix(promo) {
  var returnVal = '';
  if (promo.extpromoid) {
    returnVal = 'BOSS Promo';
  } else if (promo.post_tax) {
    returnVal = 'Coupon';
  } else {
    returnVal = 'Promotion';
  }
  if (promo.coupon_campaign) {
    returnVal += '-' + promo.coupon_campaign;
  }
  return returnVal;
};
var _priceFilter = function _priceFilter(cents, showmt) {
  if (null === cents) {
    return null;
  }
  if (!showmt && cents === 0) {
    return '';
  }
  if (!isNumeric(cents)) {
    return cents;
  }
  var neg = '';
  if (cents < 0) {
    neg = '-';
    cents = -cents;
  }
  return neg + (cents / 100).toFixed(2);
};
var addBuyMoreAndSave = function addBuyMoreAndSave(items, savingsMap) {
  var _iterator = _createForOfIteratorHelper(savingsMap),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var savingsEntry = _step.value;
      var itemIdToMatch = String(savingsEntry.itemId);
      var item = items[itemIdToMatch];
      if (item) {
        var currentBuyMoreAndSaveData = _objectSpread({}, savingsEntry);
        delete currentBuyMoreAndSaveData.itemId;
        if (!item.buyMoreAndSave) {
          item.buyMoreAndSave = [];
        }
        item.buyMoreAndSave.push(currentBuyMoreAndSaveData);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return items;
};
var usePromoService = function usePromoService(purchaseService) {
  var _fetchActivePromos = function _fetchActivePromos() {
    var promotions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    mypromos.length = 0;
    promotions.forEach(function (p) {
      p.maxoffers_orig = p.maxoffers;
      if (p.type == 'discount' || p.type == 'price') {
        mypromos.unshift(p);
      } else {
        mypromos.push(p);
      }
    });
  };
  var _adjustExternalPromos = function _adjustExternalPromos(localPromoUsage, cloudPromoUsage) {
    var _loop = function _loop() {
      // ...only for external promos
      if (!mypromos[pndx].extpromoid) {
        return 1; // continue
      }
      var p = mypromos[pndx];

      // ...what's the local usage for this promo ?
      var localExcercisedOffers = 0;
      localPromoUsage.forEach(function (externalPromoItem) {
        if (externalPromoItem.extpromoid == p.extpromoid) {
          localExcercisedOffers = externalPromoItem.exercised_offers;
        }
      });
      if (localExcercisedOffers >= p.maxoffers) {
        p.maxoffers = -1;
      } else {
        var cloudExcercisedOffers = 0;
        cloudPromoUsage.forEach(function (externalPromoItem) {
          if (externalPromoItem.extpromoid == p.extpromoid) {
            cloudExcercisedOffers = externalPromoItem.exercised_offers;
          }
        });
        if (cloudExcercisedOffers >= p.maxoffers) {
          p.maxoffers = -1;
        } else {
          p.maxoffers -= Math.max(localExcercisedOffers, cloudExcercisedOffers);
        }
      }
    };
    // ...adjust remaining offers based on what we found
    for (var pndx = 0; pndx < mypromos.length; ++pndx) {
      if (_loop()) continue;
    }
  };
  var initializePromos = function initializePromos() {
    var promotions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var localPromoUsage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var cloudPromoUsage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    _fetchActivePromos(promotions);
    _adjustExternalPromos(localPromoUsage, cloudPromoUsage);
  };
  var addPromosPtfs = function addPromosPtfs() {
    purchaseService.priceTaxFeeAdjusters = purchaseService.priceTaxFeeAdjusters.filter(function (a) {
      return a.name !== 'promo';
    });
    promoService.priceTaxFeeAdjuster.nextId = 0;
    purchaseService.priceTaxFeeAdjusters.push(new promoService.priceTaxFeeAdjuster({
      promos: mypromos.filter(function (a) {
        return !a.extpromoid && !a.post_tax;
      }),
      positioning: 'pretax'
    }),
    /*
     * we must remember that no New Price promo can be post tax so we must filter those from the
     * next selection - eventually
     */
    new promoService.priceTaxFeeAdjuster({
      promos: mypromos.filter(function (a) {
        return a.extpromoid || a.post_tax;
      }),
      positioning: 'posttax'
    }));
  };
  var getPromoDescriptions = function getPromoDescriptions(p) {
    var promos = [];
    if (p.priceTaxFeeAdjustments && p.priceTaxFeeAdjustments.length) {
      p.priceTaxFeeAdjustments.forEach(function (a) {
        if (a.name === 'promo' && !a.extra.feeBuster) {
          var _a$extra$tier, _a$extra$tier2;
          var description = [];
          var promo = a.extra.promo;
          var descriptionPrefix = _getPromoDescriptionPrefix(promo);
          /*
           * we don't always rely on the tier for qty / cents as it could be a promo from before the
           * promo-tier release
           */
          var promoQty = ((_a$extra$tier = a.extra.tier) === null || _a$extra$tier === void 0 ? void 0 : _a$extra$tier.qty) || promo.pricing.qty;
          var promoCents = ((_a$extra$tier2 = a.extra.tier) === null || _a$extra$tier2 === void 0 ? void 0 : _a$extra$tier2.cents) || promo.pricing.cents;
          if (promo.type.search('percentdiscount') !== -1) {
            description = [descriptionPrefix, ' ' + promoCents + '%' + ' off ' + (promoQty == 1 ? 'each' : '/ ' + promoQty)];
          } else if (promo.type.search('discount') !== -1) {
            description = [descriptionPrefix, ' $' + _priceFilter(promoCents) + ' off ' + (promoQty == 1 || promo.type === 'mpr-discount' ? 'each' : '/ ' + promoQty)];
          }
          if (promo.type.match(/price$/)) {
            var feeBusterCoef = 1;
            var hasPriceIncrease = false;
            if (purchaseService.getPriceFn.withCcFee && purchaseService.priceIncrease) {
              var feebusterPtf = p.priceTaxFeeAdjustments.find(function (a) {
                return a.name === 'feebuster';
              });

              // only if feebuster price <> 0
              if (feebusterPtf && feebusterPtf.price) {
                hasPriceIncrease = true;
              }
            }
            if (hasPriceIncrease) {
              feeBusterCoef += purchaseService.feeBusterConfig.fraction;
            }
            if (promo.type.match(/^(mbq|mpr)/)) {
              description = [descriptionPrefix, ' Buy ' + promoQty + ' for $' + _priceFilter(promoCents * feeBusterCoef)];
            } else {
              var unitPrice = p.skuprice / p.skuqty;
              description = [descriptionPrefix, ' $' + _priceFilter((promoQty * unitPrice - promoCents) * feeBusterCoef) + ' off ' + (promoQty == 1 ? 'each' : '/ ' + promoQty)];
            }
          }
          if (promo.byweight && description[description.length - 1]) {
            description[description.length - 1] += ' lb';
          }
          var promoPrice = a.price * (p.refund ? -1 : 1);
          if (a.extra.addFeebuster) {
            var feebusterPromoPtf = p.priceTaxFeeAdjustments.find(function (b) {
              return a.name === b.name && a.id === b.id && b.extra.feeBuster;
            });
            if (feebusterPromoPtf) {
              promoPrice += feebusterPromoPtf.price;
            }
          }
          promos.push({
            description: description,
            price: _priceFilter(promoPrice)
          });
        }
      });
    }
    return promos;
  };
  var getBuyMoreAndSaveList = function getBuyMoreAndSaveList() {
    var moreAndSaveList = [];
    var feeBusterConfig = purchaseService.feeBusterConfig,
      purchases = purchaseService.purchases,
      reg = purchaseService.reg;

    /*
     * only applicable to promos with a required buying quantity. by-weight promos are
     * automatically excluded by this rule.
     */
    var promosWithMinimumQuantity = mypromos.filter(function (a) {
      return a.type.match(/^(mbq|mpr|mpo)-/) && a.pricing.qty > 1;
    }); // in case of illogically configured promo
    var _iterator2 = _createForOfIteratorHelper(promosWithMinimumQuantity),
      _step2;
    try {
      var _loop2 = function _loop2() {
          var _promo$extension;
          var promo = _step2.value;
          // filters out BR promotions if no brnumber is provided
          if (promo.extpromoid && !reg.brnumber) {
            return 0; // continue
          }
          var lastItemWithPromo = -1;
          var quantityOfEligiblesBought = 0;
          for (var index = 0; index < purchases.length; ++index) {
            var product = purchases[index];
            if (!product.payment && !product.refund && !product.isFree && promo.upcs.includes(product.upc)) {
              lastItemWithPromo = index;
              quantityOfEligiblesBought += product.qty;
            }
          }
          if (quantityOfEligiblesBought === 0 || lastItemWithPromo === -1) {
            return 0; // continue
          }
          var promoQty = promo.pricing.qty;
          var promoCents = promo.pricing.cents;
          if (promo.type === 'mbq-discount' && (_promo$extension = promo.extension) !== null && _promo$extension !== void 0 && (_promo$extension = _promo$extension.tiers) !== null && _promo$extension !== void 0 && _promo$extension.length && quantityOfEligiblesBought >= promoQty) {
            promo.extension.tiers.some(function (t) {
              if (quantityOfEligiblesBought < t.qty) {
                promoQty = t.qty;
                promoCents = t.cents;
                return true;
              }
              return false;
            });
          }
          var isMultipack = ['mpr-discount', 'mpo-discount'].includes(promo.type);
          var itemsNeeded = isMultipack ? promoQty - quantityOfEligiblesBought : promoQty - quantityOfEligiblesBought % promoQty;
          if (itemsNeeded > 0 && itemsNeeded < promoQty) {
            // Check if the maximum number of offers has been reached
            if (promo.maxoffers && quantityOfEligiblesBought / promoQty >= promo.maxoffers) {
              return 0; // continue
            }
            var lastitem = purchases[lastItemWithPromo];
            var savings = 0;
            if (promo.type.match(/percentdiscount$/)) {
              savings = "".concat(promoCents, "%");
            } else if (promo.type.match(/discount$/)) {
              savings = promoCents * (promo.type === 'mpr-discount' ? promoQty : 1);
            } else {
              // "new price" promo
              var feeBusterCoef = 1;
              if (lastitem.priceTaxFeeAdjustments) {
                var feeBusterPtf = lastitem.priceTaxFeeAdjustments.find(function (a) {
                  return a.name === 'feebuster';
                });
                if (feeBusterPtf && feeBusterPtf.price && feeBusterConfig.fraction) {
                  feeBusterCoef += feeBusterConfig.fraction;
                }
              }
              var pricePerItem = lastitem.skuprice / lastitem.skuqty;
              var savingsPerPromoInstance = promoQty * pricePerItem - promoCents;
              savings = round(savingsPerPromoInstance * feeBusterCoef);
            }
            moreAndSaveList.push({
              itemId: lastitem.uuid,
              itemsNeeded: itemsNeeded,
              savings: savings,
              promoId: promo.id
            });
          }
        },
        _ret;
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _ret = _loop2();
        if (_ret === 0) continue;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return moreAndSaveList;
  };
  var getBuyOneMoreAndSaveList = function getBuyOneMoreAndSaveList() {
    var buyOneMoreAndSaveList = {};
    var feeBusterConfig = purchaseService.feeBusterConfig,
      purchases = purchaseService.purchases;
    /*
     * only applicable to promos with a required buying quantity. by-weight promos are
     * automatically excluded by this rule.
     */
    var promosWithMinimumQuantity = mypromos.filter(function (a) {
      return a.type.match(/^(mbq|mpr|mpo)-/) && a.pricing.qty > 1;
    }); // in case of illogically configured promo
    var _iterator3 = _createForOfIteratorHelper(promosWithMinimumQuantity),
      _step3;
    try {
      var _loop3 = function _loop3() {
        var _promo$extension2;
        var promo = _step3.value;
        var lastItemWithPromo = -1;
        var quantityOfEligiblesBought = 0;
        for (var index = 0; index < purchases.length; ++index) {
          var product = purchases[index];
          if (!product.payment && !product.refund && !product.isFree && promo.upcs.includes(product.upc)) {
            lastItemWithPromo = index;
            quantityOfEligiblesBought += product.qty;
          }
        }
        var types = ['promo', 'brPromo'];
        var promoQty = promo.pricing.qty;
        var promoCents = promo.pricing.cents;
        if (promo.type === 'mbq-discount' && (_promo$extension2 = promo.extension) !== null && _promo$extension2 !== void 0 && (_promo$extension2 = _promo$extension2.tiers) !== null && _promo$extension2 !== void 0 && _promo$extension2.length && quantityOfEligiblesBought >= promoQty) {
          promo.extension.tiers.some(function (t) {
            if (quantityOfEligiblesBought < t.qty) {
              promoQty = t.qty;
              promoCents = t.cents;
              return true;
            }
            return false;
          });
        }
        if (quantityOfEligiblesBought && (
        // if multipack, and the quantity bought is one less than the promo
        ['mpr-discount', 'mpo-discount'].includes(promo.type) && promoQty - quantityOfEligiblesBought === 1
        /*
         * or regular promo, and the quantity bought, modulus the promo quantity, is one less
         * than the promo
         */ || !['mpr-discount', 'mpo-discount'].includes(promo.type) && quantityOfEligiblesBought % promoQty === promoQty - 1 && (!promo.maxoffers || quantityOfEligiblesBought / promoQty < promo.maxoffers))) {
          var lastitem = purchases[lastItemWithPromo];
          var type = types[promo.extpromoid ? 1 : 0];
          buyOneMoreAndSaveList[lastitem.uuid] = buyOneMoreAndSaveList[lastitem.uuid] || {};
          buyOneMoreAndSaveList[lastitem.uuid][type] = buyOneMoreAndSaveList[lastitem.uuid][type] || 0;
          if (promo.type.match(/percentdiscount$/)) {
            buyOneMoreAndSaveList[lastitem.uuid][type] = promoCents + '%';
          } else if (promo.type.match(/discount$/)) {
            buyOneMoreAndSaveList[lastitem.uuid][type] += promoCents * (promo.type === 'mpr-discount' ? promoQty : 1);
          } else {
            // "new price" promo
            var feeBusterCoef = 1;
            if (lastitem.priceTaxFeeAdjustments) {
              var feeBusterPtf = lastitem.priceTaxFeeAdjustments.find(function (a) {
                return a.name === 'feebuster';
              });
              if (feeBusterPtf && feeBusterPtf.price && feeBusterConfig.fraction) {
                feeBusterCoef += feeBusterConfig.fraction;
              }
            }
            buyOneMoreAndSaveList[lastitem.uuid][type] += round((promoQty * lastitem.skuprice / lastitem.skuqty - promoCents) * feeBusterCoef);
          }
        }
      };
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        _loop3();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    return buyOneMoreAndSaveList;
  };
  return {
    initializePromos: initializePromos,
    addBuyMoreAndSave: addBuyMoreAndSave,
    addPromosPtfs: addPromosPtfs,
    getPromoDescriptions: getPromoDescriptions,
    getBuyOneMoreAndSaveList: getBuyOneMoreAndSaveList,
    getBuyMoreAndSaveList: getBuyMoreAndSaveList
  };
};
module.exports = usePromoService;